import StandardError from '../StandardError'

export default class Received7Days extends StandardError {
  constructor() {
    super(
      "We're sorry, we cannot assist in tracking items that have been marked as received for more than 7 days. Thanks for understanding."
    )
  }
}
